// extracted by mini-css-extract-plugin
export default {"container":"sender_container__DcT0t"};